import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  userInfo: null,
  businessId: null // 添加 businessId
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserInfo: (state, action) => {
      state.userInfo = action.payload.userInfo
      state.businessId = action.payload.businessId // 添加 businessId
    },
    clearUserInfo: (state) => {
      state.userInfo = null
      state.businessId = null // 清除 businessId
    }
  }
})

export const { setUserInfo, clearUserInfo } = userSlice.actions
export default userSlice.reducer
